var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuResultColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.77331 17.9999V17.9999L7.62643 17.9401C4.14582 16.4442 1.72596 13.5231 0.632366 9.4923C0.126884 7.64352 -0.0776506 5.72773 0.0266086 3.81588L0.0514825 3.50348L0.369464 3.49189C3.08242 3.44235 5.65632 2.30647 7.49203 0.347715L7.77332 -0.000108L8.05461 0.347715C8.58429 0.938448 9.19795 1.45146 9.87654 1.87059C11.4605 2.87347 13.2929 3.43399 15.1771 3.49256L15.4958 3.5041L15.52 3.81655C15.6223 5.72773 15.4177 7.64281 14.9142 9.49231C13.8193 13.5224 11.4008 16.4442 7.92016 17.9401L7.77331 17.9999Z",
    fill: "url(#paint0_linear_306_34)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76569 8.84513C4.57231 8.84513 4.38743 8.92808 4.26093 9.07206C4.04721 9.31249 4.04721 9.67186 4.26093 9.91224L5.9655 11.5805C6.22118 11.8325 6.63619 11.8331 6.89254 11.583L6.89518 11.5805L11.2491 7.32859C11.3743 7.21098 11.4451 7.04833 11.4457 6.87864C11.4464 6.70632 11.375 6.54109 11.2491 6.42089C10.9901 6.16952 10.5725 6.16952 10.3129 6.42089L6.43362 10.2138L5.19123 9.00004C5.07324 8.89974 4.92243 8.84513 4.76569 8.84513Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_34",
    x1: 0.00134473,
    y1: 0.000108,
    x2: 0.00134473,
    y2: 18.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#75DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C621"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuResultColor);
export default __webpack_public_path__ + "static/media/menu-result-color.c6f3d9df81316053a796d897757dbce3.svg";
export { ForwardRef as ReactComponent };